/**
 * Created by ivan on 06.02.18.
 */

const FireworkCell = function (x, y, color) {
    BaseCell.call(this, x, y);

    this.addComponent(ColorComponent, { color });
    this.addComponent(SpecialColorComponent);

    this.createType = undefined;
    this.totalDuration = 0;

    this.onOutburstListener = function () {};
    
    this.putInPoolAvailable = true;
};

FireworkCell.prototype = Object.create(BaseCell.prototype);
FireworkCell.prototype.constructor = FireworkCell;

FireworkCell.prototype.editorComponents = function () {
    return [BaseCellComponent, SwitchModeComponent];
};

FireworkCell.prototype.getViewClass = function () {
    return FireworkCellView;
};

FireworkCell.prototype.explode = function (params) {
    if (this.createType === CreateTypes.CREATE_AGAIN_TYPE) {
        Game.currentGame.field.addNextCell(FireworkCell.CODES.concat([CreateTypes.CREATE_AGAIN_TYPE, "."]));
    }
    BaseCell.prototype._explode.call(this, params);
};

FireworkCell.prototype.hurt = function (params) {
    if (this.lives < 1 || !this.alive) {
        return;
    }

    const options = CombosLibrary.helpers.classifyTargets();

    let chosen;

    if (options.simple.length > 0 && options.special.length > 0) {
        chosen = [PseudoRandom.GET().choose(options.simple), PseudoRandom.GET().choose(options.special)];
    } else {
        let nonEmpty = options.simple;
        if (nonEmpty.length === 0) {
            nonEmpty = options.special;
        }

        nonEmpty = PseudoRandom.GET().shuffle(nonEmpty);
        chosen = nonEmpty.slice(0, 2);
    }

    chosen.forEach((cell, index) => {
        cell.prepareForBurn();
        const flyDuration = this.getFlyDuration(cell);
        const duration = FireworkCell.HURT_DELAY + (index + 1) * FireworkCell.ANIMATION_DURATION + flyDuration;
        this.totalDuration = Math.max(this.totalDuration, duration);
        Game.currentGame.counter.setTimeout(() => {
            cell.hurt({ id: index, groupSize: chosen.length });
            RugTile.hurtViaCombo(this, cell);
        }, duration * 1000);
    });
    this.onOutburstListener(chosen);
    this.hurtedCells = chosen.length;

    BaseCell.prototype.hurt.call(this, params);
};

FireworkCell.prototype.getFlyDuration = function (cell) {
    const dist = Math.abs(cell.x - this.x) + Math.abs(cell.y - this.y);
    let duration = dist / FireworkCell.FLY_SPEED;
    duration = Math.max(duration, FireworkCell.MIN_FLY_DURATION);
    duration = Math.min(duration, FireworkCell.MAX_FLY_DURATION);
    return duration;
};

FireworkCell.prototype.load = function (data) {
    this.createType = data[1];

    const color = data[2];
    const colorComponent = this.findComponent(ColorComponent);
    colorComponent.setColor(color === "." ? this.getRandomColor() : color);
};

FireworkCell.prototype.save = function () {
    return FireworkCell.CODES.concat([this.createType, this.findComponent(ColorComponent).color]);
};

FireworkCell.prototype.hurtDuration = function () {
    if (this.hurtedCells === 0) {
        return 0;
    }
    return FireworkCell.HURT_DELAY + this.hurtedCells * FireworkCell.ANIMATION_DURATION;
};

FireworkCell.prototype.explodeDuration = function () {
    return this.totalDuration - this.hurtDuration();
};

FireworkCell.prototype.getGoalId = function () {
    return FireworkCell.GOAL_ID;
};

FireworkCell.prototype.bundleId = function () {
    return "firework_cell";
};

FireworkCell.GOAL_ID = "firework";

FireworkCell.HURT_DELAY = 0.3;
FireworkCell.ANIMATION_DURATION = 0.4;
FireworkCell.FLY_SPEED = 10;
FireworkCell.MIN_FLY_DURATION = 0.8;
FireworkCell.MAX_FLY_DURATION = 2.5;